//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from "store/constants";

//  ----------------------------------------------------------------------------
//  Actions
//  ----------------------------------------------------------------------------

//  -- Create interaction -------------
export const createOneGameCategory = (returnedPayload) => ({
  type: ActionTypes.one_game_category.create_one_game_category,
  payload: returnedPayload,
});

// Removed unused updateOneGameCategory

export const deleteOneGameCategory = (returnedPayload) => ({
  type: ActionTypes.one_game_category.delete_one_game_category,
  payload: returnedPayload,
});

export const listOneGameCategory = (returnedPayload) => ({
  type: ActionTypes.one_game_category.list_one_game_category,
  payload: returnedPayload,
});
